/* MADSHRIMP delivery messaging (draft theme).
 * Keeps the cart-drawer (and cart page) delivery message in sync with the cart.
 * The message HTML is rendered server-side by snippets/ms-cart-delivery.liquid via the
 * alternate view /cart?view=ms-delivery, so the livestock detection and state logic
 * live in one place (Liquid). This file only fetches and injects it.
 * Hooks: the theme's ajaxCart triggers 'ajaxCart.afterCartLoad' on <body> after every
 * drawer build (open, add, qty change, remove).
 */
(function () {
  'use strict';
  var seq = 0;
  var lastHtml = null;

  function targets() {
    return document.querySelectorAll('[data-ms-cart-delivery]');
  }

  function apply(html) {
    lastHtml = html;
    var els = targets();
    for (var i = 0; i < els.length; i++) {
      els[i].innerHTML = html;
    }
  }

  function refresh() {
    if (!targets().length) return;
    // Show the previous message immediately (avoids a blank gap while re-fetching).
    if (lastHtml !== null) {
      var els = targets();
      for (var i = 0; i < els.length; i++) {
        if (!els[i].innerHTML) els[i].innerHTML = lastHtml;
      }
    }
    var mine = ++seq;
    var url = '/cart?view=ms-delivery&_=' + Date.now();
    var done = function (html) { if (mine === seq) apply((html || '').trim()); };
    try {
      if (window.fetch) {
        fetch(url, { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(done)['catch'](function () {});
      } else if (window.jQuery) {
        window.jQuery.get(url, done);
      }
    } catch (e) { /* never break the cart */ }
  }

  function bind() {
    if (window.jQuery) {
      // Bound on <body> (not document) because the theme calls $(document).off('ajaxCart.afterCartLoad').
      window.jQuery('body').on('ajaxCart.afterCartLoad', function () { setTimeout(refresh, 0); });
    }
    window.MSDelivery = { refresh: refresh };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
